import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_ORDER_URL

export const uploadFile = async (data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }

  const res = await apiClientV2.put('/product/import/file', formData, {
    method: 'PUT',
    baseURL,
    headers: { 'Content-Type': 'multipart/form-data' },
  })

  return res?.data
}

export const createProduct = async (data) => {
  const res = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/product/import',
    data,
  })

  return res?.data
}

export const getDetail = async (id) => {
  const res = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/product/import/${id}`,
  })

  return res?.data
}

export const getImportResult = async (importId, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam.sorts?.length > 0 ? queryParam.sorts : undefined,
    format: queryParam.format,
    resource: queryParam.resource,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/product/import/${importId}/result`,
    params: params,
  })

  return response?.data
}
